/* ViolationsComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./ViolationsRenderer");
const FullTextComponent = require("../../veil/fullText/FullTextComponent");

class ViolationsComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value, context);
        this._value = value;
        this._context = context;
        this._userFeedback = _.get(context, "userFeedback");
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._context = undefined;
        this._userFeedback = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }
    setLinks(newVal) {
        this._value = newVal;
        this.emit("Links", newVal);
    }

    getValue() {
        return this.getLinks();
    }
    getLinks() {
        return this._value;
    }

    openFullText(text) {
        if (!this._userFeedback) {
            return Promise.resolve();
        }
        return this._userFeedback
            .displayCustom(new FullTextComponent(text, "Violations"), {notDismissable: false})
            .catch(() => {
                // Dismissing the veil rejects with {userRejected: true}; nothing to do.
            });
    }

    getViolations() {
        let Violations = this._value.evalResults || {};
        return Violations;
    }
    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
}

module.exports = ViolationsComponent;
